import { useTranslation } from "react-i18next";
import { DataEntryAccidentStepSectionProps, typedMemo } from "src/types";
import { FormRow, InputDate, InputHour, InputText } from "src/ui/widgets";

export const DataEntryAccidentStepGeneralInfo = typedMemo(
  ({
    formikAccidentValues,
    formikAccidentErrors,
    formikAccidentTouched,
    formik,
    validationSchema,
  }: DataEntryAccidentStepSectionProps) => {
    const { t } = useTranslation();

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    return (
      <>
        <FormRow
          firstField={
            <InputDate
              name="accidentData.generalInfo.accidentDate"
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikAccidentTouched?.generalInfo?.accidentDate}
              value={formikAccidentValues.generalInfo?.accidentDate}
              error={formikAccidentErrors?.generalInfo?.accidentDate}
              label={`${t("data_entry.accident_step.section_general_info_accident_date")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
          secondField={
            <InputHour
              name="accidentData.generalInfo.accidentHour"
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikAccidentTouched?.generalInfo?.accidentHour}
              value={formikAccidentValues.generalInfo?.accidentHour}
              error={formikAccidentErrors?.generalInfo?.accidentHour}
              label={`${t("data_entry.accident_step.section_general_info_accident_hour")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name="accidentData.generalInfo.accidentLocation"
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikAccidentTouched?.generalInfo?.accidentLocation}
              value={formikAccidentValues.generalInfo?.accidentLocation}
              error={formikAccidentErrors?.generalInfo?.accidentLocation}
              label={`${t("data_entry.accident_step.section_general_info_accident_place")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
      </>
    );
  }
);
